export default function processArguments (args, str) {
    if (!args.length) return str
    str += `( `
    for (let index = 0; index < args.length; index++) {
        const arg = args[index];
        str += `${arg.name}:$${arg.name} `
    }
    str += `)`
    return str
}